import { uri } from '../constants';
import axios from 'axios';

/**
 * Get all splits for a user
 * @param {string} userId - The user ID
 * @returns {Promise<Object>} - The splits data
 */
export const getUserSplits = async (userId) => {
  try {
    const response = await axios.get(`${uri}/splits/user/${userId}/splits`);
    return response.data.splits;
  } catch (error) {
    console.error('Error fetching user splits:', error);
    throw error;
  }
};

/**
 * Get all invite splits for a user
 * @param {string} userId - The user ID
 * @returns {Promise<Object>} - The invite splits data
 */
export const getUserInviteSplits = async (userId) => {
  try {
    const response = await axios.get(`${uri}/splits/user/${userId}/invite-splits`);
    return response.data.inviteSplits;
  } catch (error) {
    console.error('Error fetching user invite splits:', error);
    throw error;
  }
};

/**
 * Get all splits and invite splits for a user
 * @param {string} userId - The user ID
 * @returns {Promise<Object>} - Object containing both splits and invite splits
 */
export const getAllUserSplits = async (userId) => {
  try {
    const response = await axios.get(`${uri}/splits/user/${userId}/all-splits`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all user splits:', error);
    throw error;
  }
};
export const revenueShared = async (userId) => {
  try {   
      const response = await axios.get(`${uri}/splits/user/${userId}/revenue_shared`)
      console.log(response)
      return response.data;
  } catch(error){
    console.error('erro', error)
    throw error
  }
}

/**
 * Create a new split
 * @param {Object} splitData - The split data
 * @param {string} splitData.user_id - User ID
 * @param {string} splitData.email - User's email address
 * @param {string} splitData.title - Title
 * @param {string} splitData.isrc - ISRC code
 * @param {number} splitData.recoupment - Recoupment amount
 * @param {number} splitData.share - Share percentage
 * @returns {Promise<Object>} - The created split
 */
export const createSplit = async (splitData, isrc) => {
  try {
    const response = await axios.post(`${uri}/splits/splits/${isrc}`, splitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data.split;
  } catch (error) {
    console.error('Error creating split:', error);
    throw error;
  }
};

/**
 * Create a new invite split
 * @param {Object} inviteSplitData - The invite split data
 * @param {string} inviteSplitData.user_id - User ID
 * @param {string} inviteSplitData.email - User's email address
 * @param {string} inviteSplitData.title - Title
 * @param {string} inviteSplitData.isrc - ISRC code
 * @param {number} inviteSplitData.percentage - Percentage
 * @param {boolean} inviteSplitData.is_recoupment - Is recoupment
 * @param {number} inviteSplitData.revenue_share - Revenue share percentage
 * @returns {Promise<Object>} - The created invite split
 */
export const createInviteSplit = async (inviteSplitData) => {
  try {
    const response = await axios.post(`${uri}/splits/invite-splits`, inviteSplitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data.inviteSplit;
  } catch (error) {
    console.error('Error creating invite split:', error);
    throw error;
  }
};

/**
 * Get a specific split by ID
 * @param {string} splitId - The split ID
 * @returns {Promise<Object>} - The split data
 */
export const getSplitById = async (splitId) => {
  try {
    const response = await axios.get(`${uri}/splits/splits/${splitId}`);
    return response.data.split;
  } catch (error) {
    console.error('Error fetching split by ID:', error);
    throw error;
  }
};

/**
 * Get a specific invite split by ID
 * @param {string} inviteSplitId - The invite split ID
 * @returns {Promise<Object>} - The invite split data
 */
export const getInviteSplitById = async (inviteSplitId) => {
  try {
    const response = await axios.get(`${uri}/splits/invite-splits/${inviteSplitId}`);
    return response.data.inviteSplit;
  } catch (error) {
    console.error('Error fetching invite split by ID:', error);
    throw error;
  }
};

/**
 * Update a split
 * @param {string} splitId - The split ID
 * @param {Object} splitData - The updated split data
 * @returns {Promise<Object>} - The updated split
 */
export const updateSplit = async (splitId, splitData) => {
  try {
    const response = await axios.put(`${uri}/splits/splits/${splitId}`, splitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data.split;
  } catch (error) {
    console.error('Error updating split:', error);
    throw error;
  }
};

/**
 * Update an invite split
 * @param {string} inviteSplitId - The invite split ID
 * @param {Object} inviteSplitData - The updated invite split data
 * @returns {Promise<Object>} - The updated invite split
 */
export const updateInviteSplit = async (inviteSplitId, inviteSplitData) => {
  try {
    const response = await axios.put(`${uri}/splits/invite-splits/${inviteSplitId}`, inviteSplitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data.inviteSplit;
  } catch (error) {
    console.error('Error updating invite split:', error);
    throw error;
  }
};

/**
 * Delete a split
 * @param {string} splitId - The split ID
 * @returns {Promise<Object>} - Success message
 */
export const deleteSplit = async (splitId) => {
  try {
    const response = await axios.delete(`${uri}/splits/splits/${splitId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting split:', error);
    throw error;
  }
};

/**
 * Delete an invite split
 * @param {string} inviteSplitId - The invite split ID
 * @returns {Promise<Object>} - Success message
 */
export const deleteInviteSplit = async (inviteSplitId) => {
  try {
    const response = await axios.delete(`${uri}/splits/invite-splits/${inviteSplitId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting invite split:', error);
    throw error;
  }
};